/** Text for the 费用 page's plan quota cards. */

const HOUR = 3600;
const DAY = 24 * HOUR;
const WEEKDAYS = "日一二三四五六";

/** The window by its length: "5 小时", "每周", "30 天". */
export function windowLabel(seconds: number): string {
	if (seconds === 7 * DAY) return "每周";
	if (seconds % DAY === 0) return `${seconds / DAY} 天`;
	return `${Math.round(seconds / HOUR)} 小时`;
}

/** A countdown within a day, the local day and time beyond it. */
export function resetText(resetAt: number, now = new Date()): string {
	const minutes = Math.floor((resetAt - now.getTime()) / 60_000);
	if (minutes < 1) return "马上重置";
	if (minutes < 24 * 60) {
		const h = Math.floor(minutes / 60);
		return h > 0 ? `${h} 小时 ${minutes % 60} 分后重置` : `${minutes} 分钟后重置`;
	}
	const d = new Date(resetAt);
	const time = `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
	return `${d.getMonth() + 1}月${d.getDate()}日 周${WEEKDAYS[d.getDay()]} ${time} 重置`;
}
